import styled from 'styled-components'

export const AudioButton = styled.button`
    @media only screen and (min-width: 1024px) and (max-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
        font-size: 15px;
    }
`
